import { gql } from '@apollo/client';

export * from './escrowTerminationReject.mutation.generated';

export const ESCROW_TERMINATION_REJECT = gql`
  mutation escrowTerminationReject($escrowTerminationId: ID!) {
    escrowTerminationReject(input: { escrowTerminationId: $escrowTerminationId }) {
      success
      errors
    }
  }
`;
